import { Directive, HostBinding } from '@angular/core';

/**
 * Applied to any <th> that displays two stacked rows of text.
 * Inline styles beat Material's stylesheet without !important.
 * Pair with a child <span class="header-sublabel"> for the second row.
 * Global padding and line-height are set on th.mat-header-cell in styles.scss.
 */
@Directive({ selector: '[appTwoRowHeader]', standalone: false })
export class TwoRowHeaderDirective {
  @HostBinding('class.two-row-header') readonly twoRowHeader = true;
  @HostBinding('style.textAlign')      readonly textAlign    = 'center';
  @HostBinding('style.whiteSpace')     readonly whiteSpace   = 'nowrap';
}
